import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/login_logo.png';
import _imports_1 from '@/assets/img/login_title.png';
const _hoisted_1 = {
  class: "login-form"
};
const _hoisted_2 = {
  class: "logo-box logo-right"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "none"
  }
}, "上海文物商店", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "240px",
    "height": "100px",
    "object-fit": "contain"
  }
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "/"
}, null, -1);
const _hoisted_6 = {
  class: "login-box"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "img-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-title",
  style: {
    "height": "55px"
  },
  src: _imports_1,
  alt: ""
})], -1);
const _hoisted_8 = {
  class: "login-input"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "gap": "10px",
    "margin-bottom": "9px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "240px",
    "height": "100px",
    "object-fit": "contain"
  }
})], -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "欢迎登录", -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "上海文物商店", -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "right": "0",
    "bottom": "0",
    "left": "0",
    "height": "44px",
    "font-size": "14px",
    "color": "#666",
    "background-color": "#f7fafe"
  }
}, null, -1);
import { useRouter } from 'vue-router';
// import bkImg from '@/assets/img/login_icon2.png';//登录背景页面
import { encrypt, setToken, treeDataTranslate, setObjectToLocalStorage, getObjectFromLocalStorage } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import LoginController from '@/api/system/LoginController';

import { ref, reactive } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const loginForm = ref();
    const loginStore = useLoginStore();
    const layoutStore = useLayoutStore();
    const router = useRouter();
    const dataForm = reactive({
      // mobilePhone: 'admin',
      // password: '123456',
      //  mobilePhone: 'test',
      //  password: '123456',
      mobilePhone: '',
      password: '',
      rememberPassword: false
    });
    const dataRule = {
      mobilePhone: [{
        required: true,
        message: '帐号不能为空',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '密码不能为空',
        trigger: 'blur'
      }]
    };
    const dataFormSubmit = () => {
      loginForm.value?.validate(valid => {
        if (valid) {
          login();
        }
      });
    };
    // 加载保存的账号密码
    const loadSavedCredentials = () => {
      const savedCredentials = getObjectFromLocalStorage('userCredentials', {});
      if (savedCredentials.mobilePhone && savedCredentials.password) {
        dataForm.mobilePhone = savedCredentials.mobilePhone;
        dataForm.password = savedCredentials.password;
        dataForm.rememberPassword = true;
      }
    };
    // 初始化时加载保存的凭证
    loadSavedCredentials();
    const login = function (verifyParams = null) {
      let params = {
        loginName: dataForm.mobilePhone,
        password: encrypt(dataForm.password),
        captchaVerification: verifyParams?.captchaVerification
      };
      setToken(null);
      LoginController.login(params).then(data => {
        //console.log('login >>>', data);
        if (data.data.menuList) {
          layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
          delete data.data.menuList;
        }
        setToken(data.data.tokenData);
        layoutStore.setCurrentMenu(null);
        layoutStore.clearAllTags();
        if (data.data.tokenData) {
          delete data.data.tokenData;
        }
        loginStore.setUserInfo(data.data);
        // 根据用户选择保存或清除账号密码
        if (dataForm.rememberPassword) {
          setObjectToLocalStorage('userCredentials', {
            mobilePhone: dataForm.mobilePhone,
            password: dataForm.password
          });
        } else {
          setObjectToLocalStorage('userCredentials', null);
        }
        // 登录成功跳转页面
        router.replace({
          name: 'main'
        });
      }).catch(e => {
        console.error(e);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_space, {
        direction: "horizontal"
      }, {
        default: _withCtx(() => [_hoisted_4, _hoisted_5]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_space, {
        direction: "horizontal",
        style: {
          "margin-bottom": "9px"
        }
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _hoisted_10, _hoisted_11, _createVNode(_component_el_form, {
        model: _unref(dataForm),
        rules: dataRule,
        "label-position": "top",
        ref_key: "loginForm",
        ref: loginForm,
        onKeyup: _withKeys(dataFormSubmit, ["enter"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobilePhone",
            label: "",
            style: {
              "margin-top": "48px",
              "margin-bottom": "25px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobilePhone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(dataForm).mobilePhone = $event),
              style: {
                "width": "100%"
              },
              placeholder: "请输入帐号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "password",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(dataForm).password = $event),
              style: {
                "width": "100%"
              },
              type: "password",
              placeholder: "请输入密码",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24,
          style: {
            "text-align": "left",
            "margin-top": "15px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: _unref(dataForm).rememberPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dataForm).rememberPassword = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("记住账号密码")]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[3] || (_cache[3] = $event => dataFormSubmit()),
          style: {
            "width": "100%",
            "margin-top": "20px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 登录 ")]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]), _hoisted_12]);
    };
  }
});